import {style} from '@vanilla-extract/css'

export const checkbox = style({
  position: 'relative',
  display: 'inline-block',
})
